import { fetcher } from '@commenda/utils';

type UnArchiveMarketplaceServiceProps = {
  id: string;
};

const baseURL = 'marketplace/product/unarchive';

export async function unArchiveMarketplaceService({
  id,
}: UnArchiveMarketplaceServiceProps) {
  try {
    return await fetcher(`${baseURL}/${id}`, {
      method: 'POST',
    });
  } catch (err) {
    console.error(err);
    return err;
  }
}
